var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center items-center overflow-hidden"},[_c('div',{staticClass:"spinner-border w-12 h-12 border-4 rounded-full animate-spin"}),_c('div',{staticClass:"ml-5 text-3xl font-bold",class:_vm.isDark ? 'text-dark' : 'text-white'},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }